'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _jsxFileName = 'src/new-business/stage2.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _selectors = require('@marmalade/account/lib/selectors');
var _button = require('@marmalade/button');
var _button2 = _interopRequireDefault(_button);
var _domain = require('@marmalade/domain');
var _domain2 = _interopRequireDefault(_domain);
var _validation = require('@marmalade/form/lib/actions/validation');
var _addressLookup = require('@marmalade/form/lib/components/address-lookup');
var _addressLookup2 = _interopRequireDefault(_addressLookup);
var _error = require('@marmalade/form/lib/components/error');
var _error2 = _interopRequireDefault(_error);
var _form = require('@marmalade/form/lib/components/form');
var _form2 = _interopRequireDefault(_form);
var _formNavigation = require('@marmalade/form/lib/components/form-navigation');
var _formNavigation2 = _interopRequireDefault(_formNavigation);
var _scrollToError = require('@marmalade/form/lib/components/scroll-to-error');
var _scrollToError2 = _interopRequireDefault(_scrollToError);
var _claims = require('@marmalade/form/lib/questions/claims');
var _claims2 = _interopRequireDefault(_claims);
var _convictions = require('@marmalade/form/lib/questions/convictions');
var _convictions2 = _interopRequireDefault(_convictions);
var _disallowedOccupations = require('@marmalade/form/lib/questions/disallowed-occupations');
var _disallowedOccupations2 = _interopRequireDefault(_disallowedOccupations);
var _dob = require('@marmalade/form/lib/questions/dob');
var _dob2 = _interopRequireDefault(_dob);
var _email = require('@marmalade/form/lib/questions/email');
var _email2 = _interopRequireDefault(_email);
var _employment = require('@marmalade/form/lib/questions/employment');
var _employment2 = _interopRequireDefault(_employment);
var _licenceStartDate = require('@marmalade/form/lib/questions/licence-start-date');
var _licenceStartDate2 = _interopRequireDefault(_licenceStartDate);
var _marketingOptIn = require('@marmalade/form/lib/questions/marketing-opt-in');
var _marketingOptIn2 = _interopRequireDefault(_marketingOptIn);
var _modifiedVehicleKnockout = require('@marmalade/form/lib/questions/modified-vehicle-knockout');
var _modifiedVehicleKnockout2 = _interopRequireDefault(_modifiedVehicleKnockout);
var _name = require('@marmalade/form/lib/questions/name');
var _name2 = _interopRequireDefault(_name);
var _phone = require('@marmalade/form/lib/questions/phone');
var _phone2 = _interopRequireDefault(_phone);
var _vehicleInsured = require('@marmalade/form/lib/questions/vehicle-insured');
var _vehicleInsured2 = _interopRequireDefault(_vehicleInsured);
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _grid = require('@marmalade/grid');
var _formOptions = require('@marmalade/marker-study/lib/form-options');
var _message = require('@marmalade/message');
var _message2 = _interopRequireDefault(_message);
var _panel = require('@marmalade/panel');
var _progressBar = require('@marmalade/progress-bar');
var _propTypes = require('@marmalade/prop-types');
var _selectors2 = require('@marmalade/query/lib/selectors');
var _glamorous = require('glamorous');
var _propTypes2 = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reactRouterDom = require('react-router-dom');
var _renderIfBroker = require('../render-if-broker');
var _renderIfBroker2 = _interopRequireDefault(_renderIfBroker);
var _stage = require('../validation/new-business/stage2');
var _stage2 = _interopRequireDefault(_stage);
var _constants = require('./constants');
var _knockoutQuestionsComplete = require('./selectors/knockout-questions-complete');
var _knockoutQuestionsComplete2 = _interopRequireDefault(_knockoutQuestionsComplete);
var _vehicleInsured3 = require('./selectors/vehicle-insured');
var _vehicleInsured4 = _interopRequireDefault(_vehicleInsured3);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var formId = _constants.stages[1].formId;
var NewStage2 = function (_Component) {
  _inherits(NewStage2, _Component);
  function NewStage2() {
    var _ref,
      _this2 = this;
    var _temp, _this, _ret;
    _classCallCheck(this, NewStage2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewStage2.__proto__ || Object.getPrototypeOf(NewStage2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      error: ''
    }, _this.handleSubmit = function () {
      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee(formState) {
        var _options;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!formState.validAndPristine) {
                  _context.next = 11;
                  break;
                }
                _context.prev = 1;
                _options = _this.props.accessToken ? {
                  headers: {
                    Authorization: 'Bearer ' + _this.props.accessToken
                  }
                } : null;
                _context.next = 5;
                return _this.props.serverSideValidation({
                  formId: formId,
                  validationUrl: _constants.validationUrl,
                  requiredStrings: _constants.stages[1].requiredStrings,
                  requiredDates: _constants.stages[1].requiredDates,
                  callback: function callback() {
                    _this.props.history.push(_this.props.linkPrefix + '/stage3');
                  },
                  undefined: undefined,
                  options: _options
                });
              case 5:
                _context.next = 11;
                break;
              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](1);

                // Catch error from server to show as generic message
                _this.setState(Object.assign({}, _this.state, {
                  error: _context.t0.response.data.error.value
                }));
                window.scrollTo(0, 0);
              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 7]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(NewStage2, [{
    key: 'render',
    value: function render() {
      var _this3 = this;
      var isWhitelabel = this.props.theme.name !== 'Marmalade';
      if (!this.props.stage1Complete) {
        return _react2.default.createElement(_reactRouterDom.Redirect, {
          to: this.props.linkPrefix + '/stage1',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 103
          },
          __self: this
        });
      }
      var Element = this.props.container ? _grid.Container : _react.Fragment;
      return _react2.default.createElement(Element, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 107
        },
        __self: this
      }, _react2.default.createElement(_form2.default, {
        id: formId,
        product: 'ldi',
        handleSubmit: this.handleSubmit,
        validator: (0, _stage2.default)(this.props.titleOptions, this.props.employmentOptions, this.props.accessToken),
        preventSubmitOnEnterKey: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 108
        },
        __self: this
      }, _react2.default.createElement(_progressBar.WithStages, {
        newBusinessStages: _constants.stages,
        active: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 115
        },
        __self: this
      }), _react2.default.createElement('h1', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 116
        },
        __self: this
      }, _constants.stages[1].name), (this.props.hasErrors || this.state.error) && _react2.default.createElement(_message2.default, {
        type: 'error',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118
        },
        __self: this
      }, this.state.error ? this.state.error : 'There are some errors in the details you provided, please check them carefully and try\n                            again.'), _react2.default.createElement(_renderIfBroker2.default, {
        checkboxName: 'broker_stage_2',
        options: [{
          text: 'The question above has been read to the customer.',
          value: 'true'
        }],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125
        },
        __self: this
      }, _react2.default.createElement('p', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 134
        },
        __self: this
      }, 'I need to take a few personal details now. Can I please confirm you are the policyholder?')), _react2.default.createElement(_scrollToError2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 136
        },
        __self: this
      }), _react2.default.createElement(_panel.PanelAside, {
        title: 'Please could you answer the following...',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 137
        },
        __self: this
      }, _react2.default.createElement(_claims2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 138
        },
        __self: this
      }), _react2.default.createElement(_convictions2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 139
        },
        __self: this
      }), _react2.default.createElement(_disallowedOccupations2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 140
        },
        __self: this
      }), _react2.default.createElement(_modifiedVehicleKnockout2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141
        },
        __self: this
      }), _react2.default.createElement(_vehicleInsured2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 142
        },
        __self: this
      }), this.props.vehicleUninsured && _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 144
        },
        __self: this
      }, 'You may want to try our', ' ', _react2.default.createElement('a', {
        id: 'LDINewDriverLink',
        href: (0, _domain2.default)('www.wearemarmalade') + '/black-box-insurance',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146
        },
        __self: this
      }, 'Black Box Insurance'), ' ', 'which covers you in your own car, before and after you pass.')), this.props.knockoutQuestionsComplete && _react2.default.createElement('div', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 154
        },
        __self: this
      }, _react2.default.createElement('h2', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155
        },
        __self: this
      }, "Thanks! Please could you tell us a little bit more about the learner driver\u2026"), _react2.default.createElement(_panel.PanelAside, {
        title: 'Learner driver information',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156
        },
        __self: this
      }, _react2.default.createElement(_name2.default, {
        titles: this.props.titleOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 157
        },
        __self: this
      }), _react2.default.createElement(_dob2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158
        },
        __self: this
      }), _react2.default.createElement(_licenceStartDate2.default, {
        provisional: true,
        helpText: 'This date can be found on the back of the licence in column 10, row B, next to the image of the car.',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 159
        },
        __self: this
      }), _react2.default.createElement(_employment2.default, {
        options: this.props.employmentOptions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 160
        },
        __self: this
      })), _react2.default.createElement(_panel.PanelAside, {
        title: 'Learner driver contact details',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 162
        },
        __self: this
      }, _react2.default.createElement(_addressLookup2.default, {
        label: 'Learner driver address',
        defaultPostcode: this.props.knownPostcode,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163
        },
        __self: this
      }), _react2.default.createElement(_email2.default, {
        label: 'Learner driver email',
        placeholder: (isWhitelabel ? 'Marmalade' : 'We') + ' won\'t send you spam emails',
        helpText: "This should be the learner driver\u2019s email. If you\u2019d like a parent to manage your policy you can provide us your parent\u2019s email address on the next page.",
        readOnly: this.props.isHydrated,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 167
        },
        __self: this
      }), this.props.errors.email === 'Good news! We recognise your email.' ? _react2.default.createElement(_error2.default, {
        collapsePaddingAbove: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 175
        },
        __self: this
      }, _react2.default.createElement('ul', {
        style: {
          paddingLeft: '20px'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 176
        },
        __self: this
      }, _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 177
        },
        __self: this
      }, "It\u2019s quick and easy to view your quote as we already have your details \u2013 just sign in below."), _react2.default.createElement('li', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178
        },
        __self: this
      }, 'Alternatively, you can proceed using a different email address.')), _react2.default.createElement(_button2.default, {
        onClick: function onClick() {
          return _this3.props.history.push('/login');
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 180
        },
        __self: this
      }, 'Sign in')) : null, _react2.default.createElement('br', {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 184
        },
        __self: this
      }), _react2.default.createElement(_phone2.default, {
        label: 'Learner driver phone number',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 185
        },
        __self: this
      }), _react2.default.createElement(_marketingOptIn2.default, {
        label: _react2.default.createElement('span', {
          __source: {
            fileName: _jsxFileName,
            lineNumber: 188
          },
          __self: this
        }, 'Would you like to register to keep updated with driving tips, news and Marmalade product offers to be in with a chance of winning a brand-new Vauxhall Corsa? Read the', ' ', _react2.default.createElement('a', {
          href: (0, _domain2.default)('www.wearemarmalade') + '/about-us/competitions/terms-and-conditions',
          target: '_blank',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 192
          },
          __self: this
        }, 'Ts&Cs'), ' ', 'and our', ' ', _react2.default.createElement('a', {
          href: (0, _domain2.default)('www.wearemarmalade') + '/about-us/data-policy',
          target: '_blank',
          __source: {
            fileName: _jsxFileName,
            lineNumber: 201
          },
          __self: this
        }, 'privacy policy.'), ' ', 'Of course, you can unsubscribe at any time.'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186
        },
        __self: this
      }))), _react2.default.createElement(_formNavigation2.default, {
        next: {
          submit: true,
          text: 'Proceed to Step 3',
          posting: this.props.posting,
          disabled: Boolean(this.props.errors.email)
        },
        prev: {
          text: 'Back',
          link: this.props.linkPrefix + '/stage1'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 214
        },
        __self: this
      })));
    }
  }]);
  return NewStage2;
}(_react.Component);
NewStage2.propTypes = {
  linkPrefix: _propTypes2.string.isRequired,
  history: _propTypes.history.isRequired,
  stage1Complete: _propTypes2.bool.isRequired,
  posting: _propTypes2.bool.isRequired,
  knockoutQuestionsComplete: _propTypes2.bool.isRequired,
  serverSideValidation: _propTypes2.func.isRequired,
  knownPostcode: _propTypes2.string,
  titleOptions: _propTypes2.array.isRequired,
  employmentOptions: _propTypes2.array.isRequired,
  container: _propTypes2.bool.isRequired,
  isHydrated: _propTypes2.bool.isRequired
};
NewStage2.defaultProps = {
  knownPostcode: undefined
};
exports.default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(function (state) {
  return {
    hasErrors: (0, _formInfo.hasErrors)(state, formId),
    errors: (0, _formInfo.getErrors)(state, formId),
    stage1Complete: (0, _formInfo.isValidAndPristine)(state, _constants.stages[0].formId),
    posting: (0, _formInfo.isSubmittingForm)(state, formId),
    knockoutQuestionsComplete: (0, _knockoutQuestionsComplete2.default)(formId)(state),
    vehicleUninsured: (0, _vehicleInsured4.default)(formId)(state),
    knownPostcode: (0, _selectors2.getQuery)(state, 'postcode'),
    titleOptions: (0, _formOptions.options)(state).title || [],
    employmentOptions: (0, _formOptions.options)(state).employmentStatus || [],
    email: (0, _formInfo.getValues)(state, formId).email || '',
    isHydrated: (0, _formInfo.getValues)(state, formId).formIsHydrated || false,
    accessToken: (0, _selectors.getAccessToken)(state)
  };
}, {
  serverSideValidation: _validation.serverSideValidation
})((0, _glamorous.withTheme)(NewStage2)));